import React from 'react';
import { CustomTable } from '@quyva/shared-ui';
import { toSentenceCase } from '@quyva/common';
import { faGaugeHigh } from '@fortawesome/free-solid-svg-icons';
import { NoDataView } from './noDataView';

export const DiagnosticsPanel = ({ diagnostics, wrapperClassName = 'w-full' }) => {
    const di = diagnostics && typeof diagnostics === 'object' ? diagnostics : null;
    const steps = Array.isArray(di?.steps) ? di.steps : [];

    if (!di) {
        return (
            <div className={wrapperClassName}>
                <NoDataView
                    text='No diagnostics available for this repository.'
                    icon={faGaugeHigh}
                    iconColor='sky'
                />
            </div>
        );
    }

    // Convert processing time from milliseconds to seconds; format other field names as readable labels.
    const formatTotal = (fieldKey, fieldValue) => {
        if (fieldKey === 'total_processing_ms') {
            return { label: 'Processing Time', value: `${(Number(fieldValue) / 1000).toFixed(2)} s` };
        }
        return { label: toSentenceCase(fieldKey), value: String(fieldValue) };
    };
    const totals = Object.entries(di)
        .filter(([fieldKey, fieldValue]) => fieldKey !== 'steps' && fieldValue !== null && fieldValue !== undefined && fieldValue !== 0 && typeof fieldValue !== 'object')
        .map(([fieldKey, fieldValue]) => formatTotal(fieldKey, fieldValue));

    // Step columns: derived entirely from keys present in the data
    // Only skip `key` (React internal) and `metadata` (nested object)
    const allStepKeys = [
        ...new Set(steps.flatMap((step) => Object.keys(step)).filter((stepKey) => stepKey !== 'key' && stepKey !== 'metadata')),
    ];
    const identifiers = ['step_type', 'operation_name'];
    const orderedKeys = [
        ...identifiers.filter((k) => allStepKeys.includes(k)),
        ...allStepKeys.filter((k) => !identifiers.includes(k)),
    ];
    const columns = orderedKeys.map((key) => ({
        title: toSentenceCase(key),
        dataIndex: key,
        key,
        ellipsis: true,
        render: (cellValue) => {
            if (cellValue === null || cellValue === undefined) return '—';
            if (key === 'elapsed_ms') return Number(cellValue).toFixed(2);
            if (typeof cellValue === 'object') return '—';
            return String(cellValue);
        },
    }));

    return (
        <div className={wrapperClassName}>
            {totals.length > 0 && (
                <div className='w-full bg-backgrounds-white rounded-lg border p-3 mb-3'>
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-2'>
                        {totals.map((stat) => (
                            <div
                                key={stat.label}
                                className='px-3 py-2 rounded-md border bg-backgrounds-secondary flex items-center justify-between gap-2'
                            >
                                <div className='text-sm font-medium text-texts-secondary300'>
                                    {stat.label}
                                </div>
                                <div className='text-right'>{stat.value}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className='w-full bg-backgrounds-white rounded-lg border p-3'>
                <CustomTable
                    tableLayout='fixed'
                    columns={columns}
                    dataSource={steps.map((s, idx) => ({ key: idx, ...s }))}
                    pagination={{ defaultPageSize: 5 }}
                />
            </div>
        </div>
    );
};
